import { Box, Divider, Flex, Text } from "theme-ui";
import TradeRow from "./TradeRow";
import { ProjectInsight } from "../../../../../types/dashboard.types";
import TradeInsightsSkeleton from "../../skeleton/TradeInsightsSkeleton";
import React from "react";
import { useSelector } from "react-redux";

const TradesInsights = ({ projectInsights, loading, colorMode }: { projectInsights: ProjectInsight[] | null | undefined, loading: boolean, colorMode: string }) => {
    const STATUS_META = [
        { key: "done", label: "Done", color: "rgba(180, 207, 114, 1)" },
        { key: "inProgress", label: "In Progress", color: "rgba(255, 160, 96, 1)" },
        { key: "onHold", label: "On Hold", color: "rgba(234, 95, 95, 1)" },
    ];
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#252b36";
    const { flag } = useSelector((state: any) => state.dashboardData || {});
    const trades: ProjectInsight[] = projectInsights || [
        {
            name: "Mechanical",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
        {
            name: "Electrical",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
        {
            name: "Plumbing",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
        {
            name: "Structural",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
        {
            name: "Mechanical",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
        {
            name: "Fire Protection",
            done: 0,
            inProgress: 0,
            onHold: 0,
            total: 0,
        },
    ];
    if ((flag === "all-data" ||
        flag === "dashboard-data" ||
        flag === "dashboard-time-data" ||
        flag === "dashboard-project-type-data" ||
        flag !== "dashboard-trades-type-worker-manager") &&
        loading || !projectInsights) {
        return <TradeInsightsSkeleton />
    }
    return <Box sx={{ width: "100%", height: "475px" }}>
        <Box
            sx={{
                bg: bgDashboard,
                p: 20,
                borderRadius: "24px",
                boxShadow: "0px 0px 40px 0px rgba(209, 173, 138, 0.12)",
                height: "495px"
            }}
        >
            {/* Header */}
            <Text
                sx={{ fontSize: "16px", fontWeight: 600, mb: ["8px", "10px", "14px", "16px"], color: colorMode === 'light' ? '#453521' : '#f8f9fab5' }}
            >
                Trade Insights
            </Text>

            {/* Legend */}
            <Flex sx={{ display: "flex", gap: 12, my: "10px", justifyContent: "flex-start", alignItems: "center" }}>
                {STATUS_META.map((s) => (
                    <Flex
                        key={s.key}
                        sx={{
                            alignItems: "center",
                            bg: "rgba(247, 239, 229, 1)",
                            borderRadius: "6PX",
                            height: "24px",
                            width: "auto",
                            p: "3px",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px"
                        }}
                    >
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                bg: s.color,
                            }}
                        />
                        <Text sx={{ fontWeight: 500, fontSize: ["8px", "9px", "10px", "10px",] }}>{s.label}</Text>
                    </Flex>
                ))}
            </Flex>

            <Divider sx={{ borderColor: "divider", mb: "8px" }} />
            {/* Trade rows */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                {Array.isArray(trades) && trades.map((trade: { name: string }) => (
                    <TradeRow key={trade.name} trade={trade} colorMode={colorMode} />
                ))}
            </Box>
        </Box>
    </Box>
}

export default React.memo(TradesInsights)